import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { HcpAlert, ALERT_SIZE, SEVERITY } from '@hmhco/hcp-alert';
import useBootstrapOrgInfo from '../../../../hooks/bootstrapOrgInfo.hook';
import EarlyAccessPageHeading from './EarlyAccessPageHeading';
import TenantPickerLayout from '../../Layout/TenantPickerLayout';
import Logo from '../../Logo/Logo';
import useStyles from './EarlyAccessPage.styles';
import {
  getEarlyAccessShouldRenderErrorScreen,
  getEarlyAccessShouldRenderSuccessScreen,
  getEarlyAccessStep,
} from '../../../../store/selectors/EarlyAccessPageState';
import {
  setEarlyAccessStep,
  setEarlyAccessLoading,
} from '../../../../store/actions/EarlyAccessActions';
import {
  getCurrentOrg,
  getRenderInternationalForm,
} from '../../../../store/selectors/CountryStateOrg';
import SelectedOrganization from '../../SelectedOrganization/SelectedOrganization';
import EarlyAccessButtons from './EarlyAccessButtons';
import HCPCountryStateAndOrgForm from '../../../CountryStateAndOrg/HCPCountryStateAndOrgForm';
import EarlyAccessDomain from './EarlyAccessDomain';

const EarlyAccessPage = () => {
  useBootstrapOrgInfo();

  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const renderErrorState = useSelector(getEarlyAccessShouldRenderErrorScreen);
  const renderSuccessState = useSelector(
    getEarlyAccessShouldRenderSuccessScreen,
  );
  const earlyAccessStep = useSelector(getEarlyAccessStep);
  const currentOrg = useSelector(getCurrentOrg);
  const isInternational = useSelector(getRenderInternationalForm);

  const handleClick = () => {
    dispatch(setEarlyAccessLoading());
    dispatch(setEarlyAccessStep(2));
  };

  return (
    <TenantPickerLayout>
      <header>
        <Logo />
        <EarlyAccessPageHeading />
      </header>
      <main>
        <form className={classes.form}>
          {!renderSuccessState && earlyAccessStep === 1 && (
            <HCPCountryStateAndOrgForm />
          )}
          {!renderSuccessState && earlyAccessStep === 2 && (
            <>
              <SelectedOrganization
                organizationName={currentOrg?.name}
                isInternational={isInternational}
                onClick={() => {
                  dispatch(setEarlyAccessLoading());
                  dispatch(setEarlyAccessStep(1));
                }}
              />
              <EarlyAccessDomain />
            </>
          )}

          {renderSuccessState && (
            <>
              <HcpAlert
                size={ALERT_SIZE.SMALL}
                severity={SEVERITY.SUCCESS}
                title={formatMessage({
                  id: 'earlyAccess.request.success.title',
                })}
                subtitle={formatMessage({
                  id: 'earlyAccess.request.success.body',
                })}
              />
              <div className={classes.successMessage}>
                <Typography variant="body2">
                  <FormattedMessage id="earlyAccess.request.success.retry.text" />
                </Typography>
                <Button
                  className={classes.successMessageButton}
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleClick}
                >
                  <FormattedMessage id="earlyAccess.request.success.retry.buttonText" />
                </Button>
              </div>
            </>
          )}
          {!renderSuccessState && (
            <EarlyAccessButtons canSubmit={!renderErrorState} />
          )}
        </form>
      </main>
    </TenantPickerLayout>
  );
};

export default EarlyAccessPage;
